import { getDeclineNewInvitationsEnabled } from '../selectors/getStoreProperties';
/**
 * Utility function to get decline new request status
 * @returns decline new request status from store
 */
export default function getDeclineNewReqestStatus() {
    return getDeclineNewInvitationsEnabled();
}
//# sourceMappingURL=getDeclineNewReqestStatus.js.map